import { createApp } from "vue";
import App from "./App.vue";
import { VueFire } from "vuefire";
import { firebaseApp } from "./firebase";
import { createPinia } from "pinia";
import router from "./router";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "materialize-css/dist/js/materialize.min.js";
import "@/assets/css/style.styl";
import "@/assets/css/materialize.css";
import M from "materialize-css/dist/js/materialize.min.js";
import { es } from "vuetify/lib/locale";
import '@mdi/font/css/materialdesignicons.css';

import * as Sentry from "@sentry/vue";
// Store
import globalStorePlugin from "./plugins/globalStorePlugin.js";

// Filters
import { payment } from "./filters/payment";
import { currency } from "./filters/currency";
import { stock } from "./filters/stock";
import { customerDetailCashbox } from "./filters/customerDetailCashbox";
import { cashbox } from "./filters/cashbox";
import { date } from "./filters/date";
import { time } from "./filters/time";
import VueGtm from '@gtm-support/vue-gtm';

// Toast
import Vue3Toasity from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: "es",
    fallback: "es",
    messages: { es },
  },
  icons: {
    defaultSet: 'mdi',
    defaultSize: '24', // Set a default icon size
  },
});



const pinia = createPinia();

const app = createApp(App);
app.config.globalProperties.$M = M;
app.config.globalProperties.$filters = {
  payment,
  currency,
  stock,
  customerDetailCashbox,
  cashbox,
  date,
  time,
};

// Función para inicializar Sentry cuando el usuario tenga rol PosAdministration
window.initSentryForPosAdmin = (store) => {
  const authUser = store.getAuthUser;

  if (authUser && authUser.roles) {
    const hasPosAdminRole = authUser.roles.includes("PosAdministration");
    
    if (hasPosAdminRole) {
      Sentry.init({
        app,
        dsn: "https://4c76006a891fd4f178a656f4b322ebc6@o1077981.ingest.us.sentry.io/4510398629412864",
        integrations: [
          Sentry.captureConsoleIntegration({ levels: ["error"] }),
        ],
      });
      
      Sentry.setTag("userEmail", authUser?.user?.name);      
      Sentry.setTag("userRoles", authUser?.roles?.join(", "));      
    } 
  } 
};

app
  .use(VueFire, {
    firebaseApp,
  })
  .use(pinia)
  .use(globalStorePlugin)
  .use(router)
  .use(vuetify)
  .use(Vue3Toasity, {
    autoClose: 3000
  })

app.use(VueGtm, {
    id: 'GTM-PMCFHB5', // Replace with your GTM ID
    vueRouter: router, // Optional: If using Vue Router for SPA tracking
    enabled: true,
    debug: false, // Set to true for debugging in console
  });
  

app.mount("#app");

// Gateway unificado (docker-unified): el SW NO debe existir — intercepta las
// navegaciones y sirve el index legacy cacheado sin pasar por nginx, rompiendo
// el routing por cookie `bs_ux` hacia la app nueva. Desregistramos cualquier
// SW previo del origin.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()))
    .catch(() => {});
}
